import Loadable from '../../components/loadable';

const SignInForm = Loadable({
  loader: () => import('../../components/sign_in_form'),
});

angular.module('shared').value('SignInForm', SignInForm);
